export const environment = {
  production: true,
  buildId: '3235487355020971',
  configFile: 'config.json',
};
